<template>
  <div class="headquarters">
    <section class="main">
     <div class="section sectionPad section1" data-section="slide01">
        <el-carousel :interval="5000" :trigger="'click'" :arrow="'always'">
          <el-carousel-item v-for="(item,index) in banner" :key="index">
            <div class="swiper-slide">
              <img :src="item.src"  :style="{height:scrollHeight}" alt />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>联系我们</el-breadcrumb-item>
          <el-breadcrumb-item>公司总部</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 员工风采 -->
      <div class="develop">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              COMPANY
              <br />HEADQUARTERS
            </div>
            <div class="title2">公司总部</div>
          </div>
        </div>
        <div class="d_list flex">
          <li class="d_item">
            <svg
              width="80px"
              height="80px"
              viewBox="0 0 80 80"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>icon_phone</title>
              <desc>Created with Sketch.</desc>
              <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="公司总部" transform="translate(-343.000000, -740.000000)">
                  <g id="编组-6" transform="translate(325.000000, 740.000000)">
                    <g id="编组-3">
                      <g id="icon_phone" transform="translate(18.000000, 0.000000)">
                        <circle id="椭圆形" fill="#FFE800" cx="40" cy="40" r="40" />
                        <path
                          d="M43.4484264,46.9950395 C43.5050146,46.9562374 44.1526355,46.5423483 44.3412629,46.4259419 C44.6870799,46.2060633 44.9763086,46.0443879 45.2655373,45.9150475 C47.2901385,44.9708629 49.0758115,45.6369657 51.4336544,48.4759866 C52.8923733,50.2285485 53.3262164,51.7870999 52.7603341,53.1775087 C52.3390661,54.2122316 51.5342557,54.9300706 50.0943997,55.8160521 C50.0000859,55.8742552 49.1701252,56.3657486 48.9563475,56.501556 C45.6050667,58.6292049 37.9216425,53.7595404 32.3948587,45.4364882 C26.8617873,37.094035 25.4282187,28.1954182 28.8235126,26.0419012 L29.2699308,25.7508854 L29.7540746,25.4275345 C31.4705842,24.2828723 32.5709109,23.830181 33.8724403,24.0565267 C35.1739696,24.2828723 36.2805838,25.2787931 37.2174334,27.0830911 C39.1917339,30.8986317 38.7578908,32.7093968 36.217708,34.3520193 C36.0353682,34.4748927 35.3877473,34.8758478 35.3248715,34.9146499 C34.702401,35.309138 35.7587146,37.9670824 38.2108713,41.6597497 C40.6944658,45.384752 42.7693676,47.4218627 43.4484264,46.9950395 L43.4484264,46.9950395 Z"
                          id="路径"
                          fill="#4C0104"
                          fill-rule="nonzero"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div class="name">电话</div>
            <div class="desc">400 020 5177</div>
          </li>
          <li class="d_item">
            <svg
              width="81px"
              height="80px"
              viewBox="0 0 81 80"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>icon_positon</title>
              <desc>Created with Sketch.</desc>
              <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="公司总部" transform="translate(-679.000000, -740.000000)">
                  <g id="编组-6" transform="translate(325.000000, 740.000000)">
                    <g id="编组-3备份" transform="translate(201.500000, 0.000000)">
                      <g id="icon_positon" transform="translate(153.000000, 0.000000)">
                        <circle id="椭圆形" fill="#FFE800" cx="40" cy="40" r="40" />
                        <path
                          d="M40.9045885,24.0026667 C40.9367463,24.0026667 40.9682973,24.0013334 40.9998483,24 C41.0313993,24.0013334 41.0626469,24.0026667 41.0951081,24.0026667 C48.762609,24.1090694 55,29.6888889 55,36.4211105 C55,45.3333333 43.4230769,56 40.9998483,56 C38.5766197,56 27,45.3333333 27,36.4211105 C27,29.6888889 33.2376943,24.1093361 40.9045885,24.0026667 Z M41,41.5238095 C43.5773288,41.5238095 45.6666667,39.4771112 45.6666667,36.952381 C45.6666667,34.4276507 43.5773288,32.3809524 41,32.3809524 C38.4226712,32.3809524 36.3333333,34.4276507 36.3333333,36.952381 C36.3333333,39.4771112 38.4226712,41.5238095 41,41.5238095 Z"
                          id="Icon"
                          fill="#4C0104"
                          fill-rule="nonzero"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div class="name">地址</div>
            <div class="desc">广州市海珠区聚新街31号小米大厦27、28层</div>
          </li>
          <!-- <li class="d_item">
            <svg
              width="81px"
              height="80px"
              viewBox="0 0 81 80"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>icon_email</title>
              <desc>Created with Sketch.</desc>
              <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="公司总部" transform="translate(-1016.000000, -740.000000)">
                  <g id="编组-6" transform="translate(325.000000, 740.000000)">
                    <g id="编组-3备份-2" transform="translate(650.500000, 0.000000)">
                      <g id="icon_email" transform="translate(41.000000, 0.000000)">
                        <circle id="椭圆形" fill="#FFE800" cx="40" cy="40" r="40" />
                        <path
                          d="M55,32.5149395 L55,47.8573535 C55,50.1465344 53.1484375,52 50.8616071,52 L50.8616071,52 L29.1383929,52 C26.8515625,52 25,50.1465344 25,47.8573535 L25,47.8573535 L25,32.8333468 L40.0636161,39.8517139 L55,32.5149395 Z M50.8616071,28 C52.3950893,28 53.7310268,28.8345623 54.4475446,30.0746749 L54.4475446,30.0746749 L40.0636161,36.7846896 L25.4419643,30.2824775 C26.1216518,28.9284086 27.5212054,28 29.1383929,28 L29.1383929,28 Z"
                          id="形状结合"
                          fill="#4C0104"
                          fill-rule="nonzero"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div class="name">邮箱</div>
            <div class="desc">WWW.LISHANG-HUANG.COM</div>
          </li> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  scrollHeight:'',
      banner: [
        { src: require("../assets/img/headquarters/1.jpg") },
        { src: require("../assets/img/headquarters/2.jpg") },
        { src: require("../assets/img/headquarters/3.jpg") },
        { src: require("../assets/img/headquarters/4.jpg") },
      ],
    };
  },
  created() {
  	console.log('可见区高',document.body.clientHeight)
  	this.scrollHeight = (document.body.clientHeight - 100) + 'px'
  	console.log('扣减后高',this.scrollHeight)
  }
};
</script>

<style lang="scss" scoped>
.headquarters {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .slide{
    img{
      width: 100%;
    }
  }
  .develop {
    width: 1200px;
    margin: 80px auto;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'HarmonyOS Sans SC';
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 85px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .d_list {
      justify-content: space-between;
      flex-wrap: wrap;
      width: 1000px;
      height: 360px;
      margin: 0 auto;
      padding: 90px 180px;
      background: url(../assets/img/headquarters/bg_map.png) no-repeat center
        center;
      background-size: cover;
      .name {
        padding: 16px 0 10px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #4c0104;
        text-align: center;
      }
      .desc {
        font-family: 'HarmonyOS Sans SC';
        font-size: 18px;
        color: #4c0104;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss">
.section1 .carousel {
  height: calc(100vh - 100px);
}
.section1 .el-carousel__container {
  height: calc(100vh - 100px);
}
.goods .el-carousel__container {
  height: 382px;
}
.section1 .carousel img {
  width: 100%;
  // height: calc(100vh - 120px);
}
.headquarters .swiper-slide img{
  width: 100%;
  height:650px;
}
.section1 .el-carousel__indicator--horizontal,
.section1 .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: #fbea11;
  opacity: 1;
  padding: 0;
  margin-right: 10px;
}
.section1 .el-carousel__indicator.is-active {
  opacity: 1;
  background: #fbea11;
  width: 50px;
}
.section1 .el-carousel__indicators--horizontal {
  bottom: 20px;
}
.el-carousel__arrow--left{
  left:40px;
}
.el-carousel__arrow--right{
  right:40px;
}
.el-carousel__arrow i{
  color:#000;
}
.el-carousel__arrow{
  background: #fff;
}
</style>
